// The small dot on filter chips; the fill follows the text color.
export const CircleDotIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="2.4" fill="currentColor" />
    </svg>
  );
};
